import { InfoPopup } from "@/common/components";
import { useEffect, useState } from "@/common/hooks";
import labels from "@/labels/labels";

const SessionPopup = ({
  type,
  showModal,
  logoutTime,
  primaryButtonClicked,
  secondaryButtonClicked,
}) => {
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);
  const [onHideModal, setOnHideModal] = useState(() => {});

  const calculateTimeLeft = () => {
    let now = new Date().getTime();
    let difference = logoutTime - now;
    if (difference > 0) {
      setMinutes(Math.floor((difference / (60 * 1000)) % 60));
      setSeconds(Math.floor((difference / 1000) % 60));
    }
    if (difference < 0) {
      if (onHideModal) {
        onHideModal();
      }
      secondaryButtonClicked();
    }
  };

  function handleLogoutButton() {
    if (minutes > 0 || seconds > 0) {
      return `${labels?.sessionPopup?.logout} (${minutes}:${seconds})`;
    }
    return labels?.sessionPopup?.logout;
  }

  useEffect(() => {
    let interval = 0;
    if (showModal) {
      interval = setInterval(calculateTimeLeft, 1000);
    } else {
      clearInterval(interval);
      setMinutes(0);
      setSeconds(0);
    }

    return () => clearInterval(interval);
  }, [showModal, onHideModal]);

  return (
    <>
      <InfoPopup
        showModal={showModal}
        heading={
          type === "sessionExpiry"
            ? labels?.sessionPopup?.expired
            : labels?.sessionPopup?.inactive
        }
        body={
          type === "sessionExpiry"
            ? labels?.sessionPopup?.expiryAlert
            : labels?.sessionPopup?.inactiveAlert
        }
        primaryButtonText={labels?.sessionPopup?.continue}
        primaryButtonClick={() => primaryButtonClicked()}
        secondaryButtonText={handleLogoutButton()}
        secondaryButtonClick={() => secondaryButtonClicked()}
        onHideModal={(e) => {
          setOnHideModal(() => e);
        }}
      />
    </>
  );
};

export default SessionPopup;
